import React from "react";
import Section from "components/Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "components/SectionHeader";
import Auth from "components/Auth";

function AuthSection(props) {
  // Values for each auth type
  const allTypeValues = {
    otp: {
      // Top title
      title: "Įveskite kodą, gautą sms žinute",
      subtitle: "",
      // Submit button text
      buttonText: "Patvirtinti",
      // Link text to other auth types
      linkTextSignup: "Create an account",
      linkTextForgotpass: "Forgot Password?",
    },
    signup: {
      title: "Prisijunkite",
      subtitle: "Gausite sms su vienkartiniu kodu",
      buttonText: "Prisijungti",
      linkTextSignin: "Sign in",
    },
    // forgotpass: {
    //   title: "Prisijunkite",
    //   buttonText: "Prisijungti",
    // },
    // changepass: {
    //   title: "Prisijunkite",
    //   buttonText: "Prisijungti",
    // },
  };

  // Ensure we have a valid auth type
  const currentType = allTypeValues[props.type] ? props.type : "signup"; // signup is default

  // Get values for current auth type
  const typeValues = allTypeValues[currentType];

  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container
        style={{
          maxWidth: "450px",
        }}
      >
        <SectionHeader
          title={allTypeValues[currentType].title}
          subtitle={allTypeValues[currentType].subtitle || ""}
          size={2}
          spaced={true}
          className="text-center"
        />
        <Auth
          type={currentType}
          typeValues={typeValues}
          providers={props.providers}
          phone={props.phone}
          afterAuthPath={props.afterAuthPath}
          key={currentType}
        />
      </Container>
    </Section>
  );
}

export default AuthSection;
